import { styled } from "../../../stitches.config";
import { Box, FlexBox } from "../../primitives";

export const Container = styled(Box, {
  width: "100%",
});

export const Wrapper = styled(FlexBox, {
  borderTop: "1px solid #cbd5e1",
  paddingTop: 20,
  marginTop: 20,
  gap: 10,
  flexDirection: "column",
});
